export default "/images/vendor/flag-icons/flags/4x3/cn.svg?e4f6436aa2c562521a6ed835dfe48af9";